<button
  [type]="type"
  class="be-btn"
  [ngClass]="[sizeClass, variantClass, loadingClass]"
  [disabled]="isDisabled"
  [attr.title]="buttonTitle ? buttonTitle : null"
  [eevTrackClick]="eevTrackClick"
  >
  @if (!loading && variantClass !== 'be-btn--back') {
    <ng-content></ng-content>
  }
  @if (loading) {
    <app-loading-icon
      [theme]="spinnerTheme"
      [size]="spinnerSize"
    ></app-loading-icon>
  }
  @if (!loading && variantClass === 'be-btn--back') {
    <svg
      class="back-icon"
      viewbox="0 0 100 100"
      >
      <use href="assets/icons-v2/sprites.svg#chevron-left"></use>
    </svg>
  }
</button>
